import { Component, OnInit } from '@angular/core'
//import { ActivatedRoute } from '@angular/router';
import { Router } from "@angular/router"
import { HttpClient } from '@angular/common/http'
// import { CookieService } from 'ngx-cookie-service';
import { DynamicDialogRef, TreeNode } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { MessageService } from 'primeng/api';

import 'rxjs/add/operator/debounceTime';
import { environment } from 'src/environments/environment';

import { Periodicity } from 'src/app/Models/Handbooks/Periodicity';
import { Industry } from 'src/app/Models/Industry';
import { Indicator } from 'src/app/Models/Indicator'
import { MeasureUnit } from 'src/app/Models/Handbooks/MeasureUnit';
import { SourceSystem } from 'src/app/Models/Handbooks/SourceSystem';
import { InformationSource } from 'src/app/Models/Handbooks/InformationSource';
import { Activity } from 'src/app/Models/Handbooks/Activity';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';

@Component({
    selector: 'app-industry-sphere-create',
    templateUrl: './CreateSphere.html',
    styleUrls: [],
    providers: [MessageService, CurrentLangPipe]
})
export class CreateSphereComponent implements OnInit {

    IsLoading: boolean = true;

    getActivities() {
        return this.http.get(`${environment.apiUrl}/api/Activities/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    SaveChanges() {
        this.UpdatingBool = true;
        this.http.post(`${environment.apiUrl}/api/Industries/${this.IsCreatingSphere ? 'CreateSphere' : 'CreateIndustry'}`, JSON.stringify({
            Name: this.Current.Name,
            NameEn: this.Current.NameEn,
            NameKz: this.Current.NameKz,
            ActivityId: this.Current.ActivityId,
            ParentId: this.IsCreatingSphere ? 0 : this.ParentIndustry.Id
        }), {
            headers: {
                "Content-Type": "application/json",
                // "Authorization": `bearer ${this.cookieService.get('token')}`
            }
        }).subscribe(
            (data: Indicator) => {
                this.messageService.add({severity:'success', summary:'Сохранено', detail: this.IsCreatingSphere ? 'Сфера успешно добавлена!' : 'Отрасль успешно добавлена!'});
                setTimeout(() => {
                    this.ref.close(true);
                    this.UpdatingBool = false;
                }, 1200)
            },
            err => {
                this.UpdatingBool = false;
            },
            () => {
                this.UpdatingBool = false;
            }
        )
    }

    UpdatingBool: boolean = false;

    CurrentLocale: string = '';

    IsCreatingSphere: boolean = false;
    ParentIndustry: Industry = new Industry();

    Current: Industry = new Industry();
    Activities: Activity[] = [];
    get ActivitiesOptions(): Array<any> {
        var lang = this.currentLangPipe.get()
        return this.Activities.map((x) => ({
            label: (lang == 'ru')
                ? x.NameRu
                : (lang == 'kk')
                    ? x.NameKz
                    : x.NameEn,
            value: x.Id
        }))
    }

    constructor(private http: HttpClient,
        //private route: ActivatedRoute,
        private router: Router,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private messageService: MessageService,
        private currentLangPipe: CurrentLangPipe,
        // private cookieService: CookieService
    ) {
        this.IsCreatingSphere = this.config.data.isSphere;
        this.ParentIndustry   = this.config.data.parent;
        this.CurrentLocale = this.currentLangPipe.get();
    }


    ngOnInit() {
        
        this.getActivities().subscribe((data: Array<Activity>) => {
            this.Activities = data,
            this.IsLoading = false;
        })
        
    }

    // addSingle() {
    //     this.messageService.add({severity:'success', summary:'Service Message', detail:'Via MessageService'});
    // }

}